import { render } from "./ProgressBarComponent.vue?vue&type=template&id=4288c8b2"
import script from "./ProgressBarComponent.vue?vue&type=script&lang=js"
export * from "./ProgressBarComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mizuta/work/e-learning-dev/e-learning/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__